module.exports = __webpack_public_path__ + "static/media/second-font.c72dd244.svg";